import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_financial-evolution-1/artifacts/o920clpu_Ashwamedh%20Logo%20-%201.png';

export const SplashScreen = ({ onComplete }) => {
  const [phase, setPhase] = useState('logo'); // 'logo' -> 'shrink' -> 'done'

  useEffect(() => {
    const timer1 = setTimeout(() => setPhase('shrink'), 2000);
    const timer2 = setTimeout(() => {
      setPhase('done');
      onComplete();
    }, 3000);
    return () => { clearTimeout(timer1); clearTimeout(timer2); };
  }, [onComplete]);

  if (phase === 'done') return null;

  return (
    <AnimatePresence>
      {phase !== 'done' && (
        <motion.div
          className="fixed inset-0 z-[200] bg-white flex items-center justify-center"
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          data-testid="splash-screen"
        >
          <motion.img
            src={LOGO_URL}
            alt="Ashwamedh 360"
            initial={{ scale: 0.5, opacity: 0 }}
            animate={
              phase === 'logo'
                ? { scale: 1, opacity: 1 }
                : { scale: 0.15, opacity: 0, y: -300, x: -500 }
            }
            transition={
              phase === 'logo'
                ? { duration: 0.8, ease: 'easeOut' }
                : { duration: 0.8, ease: 'easeInOut' }
            }
            className="w-[300px] md:w-[400px] h-auto"
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
